import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
	isValid,
	reduxForm,
	Field,
	SubmissionError,
	initialize
} from "redux-form";
import {
	Button,
	ReduxControls
} from "rhombus-react";

import { closeModal } from "reducers/Modal";
import { savePartnerVastTag } from "reducers/creatives/VAST";

import { PARTNER_VAST_FORM } from "utils/forms";

import BasicModal from "widgets/modals/BasicModal";
import {
	partnerVastURL,
	partnerVastURLMax
} from "widgets/forms/validators/Creatives";
import { requiredNotNull } from "widgets/forms/validators/validators";
import ProgressContainer from "widgets/ProgressContainer";

import "./PartnerVASTForm.css";

const validForm = isValid(PARTNER_VAST_FORM);

export default function EditPartnerVast(props){
	let dispatch = useDispatch()
		, isValidForm = useSelector(validForm)
		, isSavingVast = useSelector(state => state.creatives.isSavingPartnerVast)
		, onClose = () => dispatch(closeModal())
		;

	function renderContent(){
		return <ReduxEditVASTForm creativeId={props.id} onClose={onClose} vastTag={props.vastTag} />;
	}

	function renderFooter(){
		return [
			<Button
				key="back"
				theme="default"
				onClick={onClose}
			>
				Cancel
			</Button>
			, <Button
				key="submit"
				theme="green"
				type="submit"
				form={PARTNER_VAST_FORM}
				disabled={!isValidForm || isSavingVast}
			>
				Save Creative
			</Button>
		];
	}

	const modalProps = {
		title: `Edit Creative - ${props.name}`,
		className: "partner-vast-tags edit-partner-vast-tags",
		onClose,
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

EditPartnerVast.displayName = "EditPartnerVast";
EditPartnerVast.defaultProps = {
	id:-1,
	name:"",
	vastTag:"",
};



function EditVASTForm(props){
	let { handleSubmit } = props
		, isSaving = useSelector(state => state.creatives.isSavingPartnerVast ?? false)
		, dispatch = useDispatch()
		;

	useEffect(() => {
		dispatch(initialize(PARTNER_VAST_FORM, { vastTag:props.vastTag }));
	}, []);

	return (
		<ProgressContainer isLoading={isSaving}>
			<div className="partner-vast-holder">
				<form
					id={PARTNER_VAST_FORM}
					className="redux-form-container partner-vast-form"
					onSubmit={handleSubmit}
				>
					<header className="header-bar-edit">Enter the VAST creative tag</header>
					<Field
						component={ReduxControls.Input}
						className="vast-tag"
						name="vastTag"
						label="Creative VAST Tag"
						required
						value={props.vastTag}
						validate={[requiredNotNull, partnerVastURL, partnerVastURLMax]}
						placeholder="Enter VAST Tag URL..."
					/>
				</form>
			</div>
		</ProgressContainer>
	);
}

EditVASTForm.displayName = "EditVASTForm";
EditVASTForm.defaultProps = {
	creativeId:-1,
};

function onSubmit(values, dispatch, formProps){
	return dispatch(savePartnerVastTag(formProps.creativeId, values))
		.then((resp) => {
			if(resp.success){
				formProps.onClose();
				return resp;
			}

			throw new SubmissionError({
				vastTag:resp.payload.errorObj.description,
			});
		});
}


const ReduxEditVASTForm = reduxForm({
	form: PARTNER_VAST_FORM,
	pure: false,
	touchOnBlur:false,
	touchOnChange:true,
	onSubmit,
})(EditVASTForm);
